import { captureException } from '@sentry/browser';
import { ReferencedEntry } from 'contentful';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ContentfulFilters, fetchEntries } from 'src/api/contentful/fetchEntries';

export function useContentfulEntries<T extends object = {}>(filterFn: () => ContentfulFilters<T>, dependencies: readonly any[] | undefined) {
  const { i18n } = useTranslation();
  const [ isError, setIsError ] = useState(false);
  const [ entries, setEntries ] = useState<ReadonlyArray<ReferencedEntry<T>>>([]);

  const internalFilter = useMemo(filterFn, dependencies);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await fetchEntries<T>(i18n.language, internalFilter);

        setEntries((result.items as unknown) as Array<ReferencedEntry<T>>);
      } catch (error) {
        const errorMessage = `Error fetching Entries with filters: ${JSON.stringify(internalFilter)}`;
        const e = new Error(errorMessage);
        e.stack = error;
        e.name = 'Error Fetching Entries';
        captureException(e);
        console.error(errorMessage, e);
        setIsError(true);
      }
    };

    fetchData();
  }, [ internalFilter ]);

  return { entries, isError };
}
